import Clarity from "@microsoft/clarity";

let didInitClarity = false;

export function initClarity(projectId: string): void {
  if (didInitClarity) {
    return;
  }
  Clarity.init(projectId);
  didInitClarity = true;
}

export function isClarityInitialized(): boolean {
  return didInitClarity;
}
